﻿import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BrowserModule } from '@angular/platform-browser';
import { TranslatetionModule } from '../translation/modules/translation.module';
import { HttpClientModule } from '@angular/common/http';
import { AppConfigModule } from 'src/config/app-config.module';
import { MessageModule } from '../components/message/modules/message.module';
import { SafeUrlPipe } from '../pipes/safe-url.pipe';
import { TruncatePipe } from '../pipes/truncate.pipe';
import { SplitPipe } from '../pipes/split.pipe';
import { HijriDatePipe } from '../pipes/hijri-date.pipe';
import { HijriDateTimePipe } from '../pipes/hijri-date-time.pipe';


@NgModule({
    imports: [
        CommonModule,
        HttpClientModule,
        TranslatetionModule,
        AppConfigModule,
        MessageModule,
    ],
    exports: [
        CommonModule,
        HttpClientModule,
        TranslatetionModule,
        MessageModule,
        SafeUrlPipe,
        TruncatePipe,
        SplitPipe,
        HijriDatePipe,
        HijriDateTimePipe
    ],
    declarations: [
        SafeUrlPipe,
        TruncatePipe,
        SplitPipe,
        HijriDatePipe,
        HijriDateTimePipe
    ],
    providers: [
    ]
})
export class CoreModule {

}